<template>
  <v-row style="padding-left: 0px;">
    <v-flex
    >
      <v-row no-gutters dense align="center">
        <v-flex md4>
          <v-text-field
            v-model="query.query"
            style="padding-top: 0px !important"
            hide-details
            solo-inverted
            rounded
            label="Search by id, name, user, pickup location, destination"
            flat
            dense
            @keyup.enter="change"
            class="px-1"
          />
        </v-flex>
 
        <v-flex shrink>
          <v-btn-toggle rounded v-model="query.includeCancelled" @change="change"  class="px-1">
            <v-btn rounded small :value="true" color="red" type="primary" style="background: grey" v-if="query.includeCancelled" >Show Active</v-btn>
            <v-btn rounded small :value="false" color="black" type="secondary" style="background: green !important; color: white" v-if="!query.includeCancelled" >Show Active</v-btn>
          </v-btn-toggle>
          <v-btn-toggle rounded v-model="query.noDriver" @change="change"  class="px-1" v-if="isDispatchCmr">
            <v-btn rounded small :value="true" color="red" type="primary" style="background: white" v-if="!query.noDriver" >No Driver</v-btn>
            <v-btn rounded small :value="false" color="black" type="secondary" style="background: green !important; color: white" v-if="query.noDriver" >No Driver</v-btn>
          </v-btn-toggle>
          <v-btn-toggle rounded v-model="query.query" @change="change"  class="px-1" v-if="isDispatchCmr">
            <v-btn rounded small :value="'scc'" type="primary" style="background: white" v-if="query.query != 'scc'" >SCC</v-btn>
            <v-btn rounded small :value="''" type="secondary" style="background: green !important; color: white" v-if="query.query == 'scc'" >SCC</v-btn>
          </v-btn-toggle>
          <v-btn-toggle rounded v-model="query.includeCancelled" @change="change"  class="px-1">
            <v-btn rounded small :value="true" color="red" type="primary" style="background: grey" v-if="!query.includeCancelled" >Archived</v-btn>
            <v-btn rounded small :value="false" color="black" type="secondary" style="background: green !important; color: white" v-if="query.includeCancelled" >Archived</v-btn>
          </v-btn-toggle>
        </v-flex>
        <v-flex class="px-1" shrink>
          <v-btn
            rounded
            small
            color="blue"
            dark
            class="text-none"
            @click="createRepeatService"
          >
            New Service
          </v-btn>
        </v-flex>
      </v-row>
    </v-flex>
  </v-row>
</template>

<script>
export default {
  name: "RepeatServiceSearchBoxV2",
  components: {},
  props: {
    query: Object,
  },
  data: function () {
    return {};
  },
  computed: {
    isDispatchCmr () {
      return this.$store.state.apiUrl.includes('cmr') || this.$store.state.apiUrl.includes('dispatch.cmr')
    }
  },
  methods: {
    createRepeatService: function () {
      this.$emit("createRepeatService", null);
    },
    change: function () {
      if(this.query.includeCancelled === undefined) {
        this.query.includeCancelled = false;
      }

      console.log("change", this.query.includeCancelled);

      this.$emit("changeQuery", null);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.search-fields {
  padding-left: 6px;
  padding-right: 6px;
}
</style>
